import React from 'react';
import { XIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { painPoints, objections } from '../data/content';
export function ProblemSection() {
  return <section aria-labelledby="problema" className="border-y border-line bg-canvasAlt" data-id="element-203" data-mp="30h7odx4u28y9">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-12 text-center" data-id="element-204" data-mp="2vqr6o0tzc163">
        <Reveal data-id="element-205" data-mp="2voob71a25ftz">
          <h2 id="problema" className="mx-auto max-w-3xl font-display text-2xl md:text-3xl font-bold uppercase leading-tight text-ink" data-id="element-206" data-mp="39hm9owhsro1r">
            Si siempre estás para los demás, probablemente te pasó esto
          </h2>
          <ul className="mx-auto mt-6 grid max-w-4xl gap-2 sm:grid-cols-2" data-id="element-207" data-mp="3jfae6e57g9x4">
            {painPoints.map(point => <li key={point} className="flex items-center justify-center gap-2.5 rounded-xl border border-line bg-surface px-4 py-3 text-sm md:text-base text-ink-muted" data-id="element-208" data-mp="3ef600urrrra2">
                <XIcon size={15} className="flex-shrink-0 text-danger" strokeWidth={2.5} data-id="element-209" data-mp="jddf4g0mmqz8" />
                <span data-id="element-210" data-mp="ocgcdead7swn">{point}</span>
              </li>)}
          </ul>
          <p className="mx-auto mt-6 max-w-xl font-display text-lg md:text-xl font-bold leading-snug text-accent" data-id="element-211" data-mp="sc8lpt7l2332">
            Y cuando finalmente aparece un momento libre… ya no te queda
            energía.
          </p>
        </Reveal>

        <Reveal delay={0.06} className="mx-auto mt-8 max-w-3xl rounded-2xl border border-line bg-surface p-6 md:p-8" data-id="element-212" data-mp="172pll84kkkxu">
          <h3 className="font-display text-xl md:text-2xl font-bold uppercase leading-tight text-ink" data-id="element-213" data-mp="1c33vywtn86z1">
            No es que no sepas cuidarte
          </h3>
          <p className="mt-2 text-base text-ink-muted" data-id="element-214" data-mp="3dtf9u7y79hrq">
            Tampoco necesitás abandonar tus responsabilidades. El problema es
            que llevás demasiado tiempo acostumbrándote a poner primero:
          </p>
          <ul className="mt-4 flex flex-wrap justify-center gap-2" data-id="element-215" data-mp="ozh5ag59pao9">
            {objections.map(obj => <li key={obj} className="rounded-full bg-blush-soft px-4 py-2 text-sm font-medium text-blush" data-id="element-216" data-mp="k27h13tm7520">
                {obj}
              </li>)}
          </ul>
          <p className="mt-5 font-display text-lg font-bold text-ink" data-id="element-217" data-mp="ty25ifkirucp">
            Y vos… siempre quedás para después.
          </p>
          <p className="mx-auto mt-3 max-w-xl text-base text-ink-muted" data-id="element-218" data-mp="1301m56rmgwf4">
            Podés seguir esperando que todo se calme para empezar a cuidarte. O
            podés aprender a recuperar pequeños espacios dentro de la vida que
            ya tenés.
          </p>
        </Reveal>
      </div>
    </section>;
}